import React from 'react';
import icon from '../../../../assets/icon.svg';

interface LoadingProps {
  title: string;
  description: string;
}

export const Loading: React.FC<LoadingProps> = ({ title, description }) => {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-white gap-2">
      <div className="flex justify-center items-center">
        <img width="200" alt="icon" src={icon} className="animate-pulse" />
      </div>
      <h1 className="text-2xl font-bold text-black">{title}</h1>
      <p className="text-lg text-gray-600">{description}</p>
    </div>
  );
};
